import styles from "./PreviewMode.module.scss";

const PreviewMode = () => (
  <div className={styles.previewMode}>Preview Mode</div>
);

export default PreviewMode;
